import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class CatalogueServiceError extends IncError {
    constructor(errorKey: string) {
        super(i18n.t(`error:catalogue.service.${errorKey}`));
        Object.setPrototypeOf(this, CatalogueServiceError.prototype);
    }
}